export const TAGS_HANDLERS = {
  DDQ: "ddq",
  GOOGLE: "google",
  TEALIUM: "tealium",
};

